import NewGoal from "main/goals/NewGoal"
import { Route, Routes } from "react-router"

const NewGoalRoute = () => {
    return <Routes>
        <Route path="*" element={<></>} />
        <Route path="/goals/new" element={<NewGoal />} />
    </Routes>
}
export default NewGoalRoute